import * as React from 'react';
import { useEditorContext } from 'ui-components/RichTextEditor/tiptap/editor_context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsToLine } from '@fortawesome/pro-regular-svg-icons';
import { useLocalization } from '~/framework';
import { MenuItem } from '@chakra-ui/react';

export const MiddleAlignButton = () => {
   const { _js } = useLocalization();
   const { editor } = useEditorContext();

   return (
      <MenuItem
         onClick={() => editor.chain().focus().setVerticalAlign('middle').run()}
         isDisabled={editor.isActive({ verticalAlign: 'middle' })}
         icon={<FontAwesomeIcon icon={faArrowsToLine} size="lg" />}
         title={_js('Middle Align')}
         iconSpacing={0}
      ></MenuItem>
   );
};
